import { MenuItem, Stack, TextField } from "@mui/material";
import { useField } from "formik";

export type UdsInputParamsFormValues = {
  mode: "connection" | "datagram";
};

export const createDefaultUdsInputParams = (): UdsInputParamsFormValues => ({
  mode: "connection"
});

type UdsInputParamsProps = {
  name?: string;
  mode?: "view" | "edit";
  datagramAvailable?: boolean;
};

const UdsInputParams = ({ name = "uds", mode = "edit", datagramAvailable = true }: UdsInputParamsProps) => {
  const readOnly = mode === "view";

  const [modeField, modeMeta, modeHelpers] = useField<UdsInputParamsFormValues["mode"]>({
    name: `${name}.mode`
  });

  return (
    <Stack spacing={2}>
      <TextField
        {...modeField}
        label="Socket mode"
        select
        value={modeField.value}
        onChange={(event) => modeHelpers.setValue(event.target.value as UdsInputParamsFormValues["mode"])}
        error={Boolean(modeMeta.touched && modeMeta.error)}
        helperText={modeMeta.touched ? modeMeta.error : !datagramAvailable ? "Datagram mode is not supported on Windows." : undefined}
        disabled={readOnly}
        fullWidth
      >
        <MenuItem value="connection">Connection (stream)</MenuItem>
        <MenuItem value="datagram" disabled={!datagramAvailable}>Datagram</MenuItem>
      </TextField>
    </Stack>
  );
};

export default UdsInputParams;
